module.exports = __webpack_public_path__ + "static/media/ACERO-INOX.b7d40d5d.mp4";